import React from "react";
import hdfc from "../assets/hdfc.png";

const PartnerPage = () => {
  return (
    <div
      className="py-5"
      style={{
        background: "linear-gradient(135deg, #eef2ff, #fdf2f8)",
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div
              className="card border-0 shadow-lg text-center p-4 rounded-4"
              style={{ background: "#ffffff" }}
            >
              <h2 className="fw-bold mb-2 text-dark">
                🤝 Our Trusted Partner
              </h2>

              <p className="text-muted mb-4">
                We proudly collaborate with our valued banking partner
              </p>

              {/* <div
                className="d-flex justify-content-center align-items-center mx-auto"
                style={{
                  width: "180px",
                  height: "100px",
                  background: "#f8fafc",
                  borderRadius: "16px",
                  boxShadow: "inset 0 0 0 1px #e5e7eb",
                }}
              > */}
                <img
                  src={hdfc}
                  alt="HDFC Bank"
                  className="img-fluid"
                  style={{
                    maxHeight: "70px",
                    objectFit: "contain",
                  }}
                />
              {/* </div> */}

              <div className="mt-4">
                <span
                  className="badge rounded-pill px-3 py-2"
                  style={{
                    background: "#e0f2fe",
                    color: "#0369a1",
                    fontSize: "0.85rem",
                  }}
                >
                  Official Partner
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerPage;
